import { createClient } from '@supabase/supabase-js';

// Para rodar localmente, crie um arquivo .env na raiz do projeto com:
//   REACT_APP_SUPABASE_URL=https://SEU-PROJETO.supabase.co
//   REACT_APP_SUPABASE_ANON_KEY=sua-anon-key
//
// Se não tiver as credenciais, o app vai carregar mas as chamadas ao
// Supabase vão falhar silenciosamente.

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'placeholder-key';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    // FIX: desabilita o sistema de locks do Supabase Auth.
    // Em Edge/Firefox o lock nativo (navigator.locks) entra em race condition
    // com múltiplas chamadas paralelas e lança "Lock was released because another
    // request stole it" — erro não-tratado que derruba o React (tela preta).
    // Em apps single-tab como o nosso, executar a função direto é seguro.
    lock: async (name, acquireTimeout, fn) => fn(),
  },
});